import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import {
    Body,
    ButtonAction,
    ButtonsContainer,
    ContentContainer,
    dialogPanel,
    dialogTitle
} from './styles'
import { IoCloseSharp } from 'react-icons/io5'
import profile from '../../../assets/svg/profile.svg'
import arrowRight from '../../../assets/svg/rightArrow.svg'
import { NotificationReducer } from 'types/notification'
import { useDispatch, useSelector } from 'react-redux'
import { RootReducerState } from 'types/global'
import NotificationService from 'services/Notification'
import { AuthenticationReducer } from 'types/autentication'
import { getRoleName } from 'utils/getRole'
import { notificationStatus } from 'constants/notificationStatus'
import NotificationActions from 'actions/Notification'
import { IUserServiceNow, UserReducer } from 'types/user'
import UserActions from 'actions/User'

interface AssumeTreatmentModalProps {
    id: string
    handleCloseModal: () => void
    isOpen: boolean
    setCurrentStepSelected: React.Dispatch<React.SetStateAction<number>>
    notificationStatusState: string
    setTooltipAlert: React.Dispatch<React.SetStateAction<string>>
}

const AssumeTreatmentModal: React.FC<AssumeTreatmentModalProps> = ({
    handleCloseModal,
    isOpen,
    setCurrentStepSelected,
    notificationStatusState,
    setTooltipAlert,
    id
}) => {
    const dispatch = useDispatch()
    const notificationDispatch = useDispatch()
    const [isTreating, setIsTreating] = useState(false)
    const [assignedTo, setAssignedTo] = useState<IUserServiceNow>()
    const notificationSelector: NotificationReducer = useSelector(
        (state: RootReducerState) => state.notificationsReducer
    )
    const usersSelector: UserReducer = useSelector(
        (state: RootReducerState) => state.userReducers
    )
    const authenticationSelector: AuthenticationReducer = useSelector(
        (state: RootReducerState) => state.authenticationReducers
    )
    const isOlder = notificationSelector.notificationById?.u_state.value != `Nova` && notificationSelector.notificationById?.u_probability_occurence?.value === ''
    const currentStepTreatments = notificationSelector?.notificationProcessRequiredStepsRules?.currentStepTreatments
    const profileStatus = useMemo(() => {
        if (authenticationSelector?.dataJwt?.profile) {
            return getRoleName(authenticationSelector?.dataJwt?.profile)
        }
    }, [authenticationSelector])
    useEffect(() => {
        const selectedUser = usersSelector?.user
        setAssignedTo(selectedUser)
    }, [usersSelector])
    useEffect(() => {
        /*
        const currentAssumed =
            notificationSelector?.notificationById?.u_assigned_to?.value
        UserActions.getByAttribute(dispatch, 'sys_id', `${currentAssumed}`)
        */
    }, [dispatch, notificationSelector])
    useEffect(() => {
        const isItTreating =
            notificationStatusState === notificationStatus[2].label
        setIsTreating(isItTreating)
    }, [notificationStatusState])
    const send = () => {
        NotificationService.assumirNotification(
            notificationSelector.notificationById?.sys_id.value,
            authenticationSelector?.dataJwt?.sys_id
        )
            .then((response: any) => {
                if (!isTreating) {
                    if(isOlder){
                        setCurrentStepSelected(2)
                    }else{
                        setCurrentStepSelected(1) // Sempre começar no step 1 (Dados da notificação)
                    }
                } else {
                    setTooltipAlert(
                        'Responsável da notificação alterado com sucesso!'
                    )
                    setTimeout(() => {
                        setTooltipAlert('')
                    }, 3000)
                }
                NotificationActions.getNotificationById(
                    notificationDispatch,
                    id
                )
                handleCloseModal()
            })
            .catch((error) => {
                console.log(error)
            })
    }
    return (
        <>
            <Transition
                appear
                show={isOpen}
                as={Fragment}
                data-testid="test-AssumirNotification"
            >
                <Dialog
                    as="div"
                    className="relative z-10"
                    onClose={handleCloseModal}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black bg-opacity-25" />
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto">
                        <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel className={dialogPanel}>
                                    <Dialog.Title
                                        as="h3"
                                        className={dialogTitle}
                                    >
                                        <p className="text-blueTheme text-xl font-semibold">
                                            {isTreating
                                                ? 'Assumir tratamento da notificação'
                                                : 'Assumir tratamento da notificação em andamento'}
                                        </p>
                                        <IoCloseSharp
                                            onClick={handleCloseModal}
                                            className="text-blueTheme h-8 w-8 p-1 cursor-pointer"
                                        />
                                    </Dialog.Title>
                                    <Body>
                                        <p className="text-xs max-w-[600px]">
                                            {isTreating
                                                ? 'Essa notificação está sendo tratada por outra pessoa. Ao assumir o tratamento, a notificação ficará em seu nome.'
                                                : 'Ao assumir o tratamento, a notificação ficará em seu nome.'}
                                        </p>
                                        {isTreating ? (
                                            <div className="flex justify-around items-center align-center ">
                                                <ContentContainerComponent
                                                    title={'Responsável atual'}
                                                    profileStatus={
                                                        assignedTo?.u_profile
                                                            ?.display_value
                                                    }
                                                    name={
                                                        notificationSelector?.notificationById?.u_assigned_to?.display_value
                                                    }
                                                />

                                                <img
                                                    className="mt-12"
                                                    src={arrowRight}
                                                    alt="logos"
                                                    width={50}
                                                />
                                                <ContentContainerComponent
                                                    title={'Novo responsável'}
                                                    profileStatus={
                                                        profileStatus?.title
                                                    }
                                                    name={
                                                        authenticationSelector
                                                            ?.dataJwt?.name
                                                    }
                                                />
                                            </div>
                                        ) : (
                                            <ContentContainerComponent
                                                title={
                                                    'Responsável pela notificação'
                                                }
                                                profileStatus={
                                                    profileStatus?.title
                                                }
                                                name={
                                                    authenticationSelector
                                                        ?.dataJwt?.name
                                                }
                                            />
                                        )}
                                        <ButtonsContainer>
                                            <ButtonAction
                                                onClick={() => {
                                                    handleCloseModal()
                                                }}
                                                type="button"
                                                className="text-blueTheme text-sm"
                                            >
                                                Cancelar
                                            </ButtonAction>

                                            <ButtonAction
                                                onClick={() => {
                                                    send()
                                                }}
                                                className="bg-blueTheme text-white text-sm"
                                            >
                                                Assumir tratamento
                                            </ButtonAction>
                                        </ButtonsContainer>
                                    </Body>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}

export default function ContentContainerComponent({
    title,
    profileStatus,
    name
}: {
    title: string
    profileStatus: string
    name: string
}) {
    return (
        <ContentContainer>
            <p className="text-sm text-center font-medium">{title}</p>
            <div className="flex items-center justify-center mt-2">
                <img src={profile} alt="logos" width={24} />
                <span className="ml-3 text-roxo text-base font-semibold">
                    {name}
                </span>
            </div>
            <p className="ml-3 text-darkGray text-center">{profileStatus}</p>
        </ContentContainer>
    )
}

export { AssumeTreatmentModal }
